import { ConfirmButtonGroup } from '@healthhub/react-ui';
import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';

interface Props {
  onCancel: () => void;
  onConfirm: () => void;
}

const HealthCaregiverRecordTypeCancelModal = ({ onCancel, onConfirm }: Props) => {
  const { t } = useTranslation();

  const onConfirmModal = () => {
    onConfirm();
    Modal.destroyAll();
  };

  return (
    <div>
      <p className="text-center text-base font-bold">{t('caregivers.addCaregivers.healthRecords.modal.title')}</p>
      <p className="mb-0">{t('caregivers.addCaregivers.healthRecords.modal.healthierSGOffNote')}</p>
      <ul className="mx-4 mb-6 list-disc">
        <li>{t('caregivers.addCaregivers.healthRecords.modal.appointmentsText')}</li>
        <li>{t('caregivers.addCaregivers.healthRecords.modal.AppointmentsBookRescheduleCancelText')}</li>
        <li>{t('caregivers.addCaregivers.healthRecords.modal.healthScreeningAndEligibilityText')}</li>
        <li>{t('caregivers.addCaregivers.healthRecords.modal.immunisationsText')}</li>
      </ul>
      <p>{t('caregivers.addCaregivers.healthRecords.modal.proceedWarningText')}</p>
      <ConfirmButtonGroup
        cancelText={t('button.cancel')}
        className="json-checked items-center lg:flex-col"
        handleCancel={onCancel}
        handleSubmit={onConfirmModal}
        okText={t('button.yes')}
      />
    </div>
  );
};

export default HealthCaregiverRecordTypeCancelModal;
